import React, { Component } from 'react';
import MobxReactForm from 'mobx-react-form';
import validatorjs from 'validatorjs';
import Cons from '../../isomorphic/cons';

const plugins = { dvr: validatorjs };

const fields = [
    'fileType',
    'address',
    'agent',
    'listingDate',
    'office',
    'propertyType',
    'typeOfSale',
    'address1',
    'address2',
    'city',
    'state',
    'zip',
    'county',
    'direction',
    'unitNum',
];
const labels = {
    fileType: 'File Type',
    address: 'Address Search',
    agent: 'Listing Agent',
    listingDate: 'List Date',
    office: 'Office',
    propertyType: 'Type',
    address1: 'Street No.',
    address2: 'Street',
    city: 'City',
    state: 'State',
    zip: 'Zip',
    county: 'County',
    direction: 'Dir.',
    unitNum: 'Unit #',
};

const types = { office: 'select', fileType: 'select', state: 'select' };
const rules = {
    listingDate: 'required',
    agent: 'required',
    propertyType: 'required',
    address1: 'required',
    address2: 'required',
    city: 'required',
    state: 'required',
    zip: 'required',
    direction: 'in:N,S,E,W,NE,NW,SE,SW',
};
const extra = { listingDate: 'date', agent: 'array' };
const disabled = {};
const bindings = {};

class MakeListingFormMobx extends MobxReactForm {
    bindings() {
        return {
            // we can choose a name as key
            ReactCheckbox: {
                id: 'id',
                name: 'name',
                type: 'type',
                value: 'checked',
                disabled: 'disabled',
                onChange: 'onChange',
            },
        };
    }
}

export default function(featureFlagStore) {
    return new MakeListingFormMobx({ fields, rules, bindings, labels, types, disabled, extra }, { plugins });
}



// WEBPACK FOOTER //
// ./src/files/make-listing-form-component.js